import { QueryClient, MutationCache } from '@tanstack/react-query';
import SweetAlert from 'components/atoms/sweetAlert';
import { SweetAlertEnums } from 'utils/enums';
import { SweetAlertConst } from 'utils/const';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 0,
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
  mutationCache: new MutationCache({
    onError: (error) => {
      // apiClient interceptor already shows SweetAlert for HTTP errors.
      // This catches non-HTTP errors (network down, code bugs, etc.)
      if (!(error as any)?.response) {
        SweetAlert({
          showSweetAlert: true,
          sweetAlertType: SweetAlertEnums.error,
          title: SweetAlertConst.error,
          subTitle: SweetAlertConst.somethingWentWrong,
        });
      }
    },
  }),
});
